import * as Sentry from '@sentry/react';
import { Route, Routes } from 'react-router-dom';

import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import {
  ENTERPRISE_LOGIN_LOGOUT_PATH,
  ORGANIZATIONS_BASE_PATH,
  PROJECTS_BASE_PATH,
  USERS_BASE_PATH,
  DATA_ADMIN_BASE_PATH,
  CONCEPT_GROUPS_BASE_PATH,
} from '@verantos-dev/core-constants';
import { DataAdminUiRoutes } from '@verantos-dev/data-admin-ui-routes';
import { LandingPage } from '@verantos-dev/el-feature-landing-page';
import { LogoutPage } from '@verantos-dev/el-feature-logout-page';
import { OrganizationsUiRoutes } from '@verantos-dev/organizations-ui-routes';
import { ConceptGroupsUiRoutes, ProjectsUiRoutes } from '@verantos-dev/projects-ui-routes';
import { AppPageLayout } from '@verantos-dev/shared-layout';
import { UsersUiRoutes } from '@verantos-dev/users-ui-routes';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function App() {
  const isConceptGroupsEnabled = useFeatureFlagSplit('concept_group_management_list');

  return (
    <SentryRoutes>
      <Route path={ENTERPRISE_LOGIN_LOGOUT_PATH} element={<LogoutPage />} />

      {/* Application Routing */}
      <Route element={<AppPageLayout />}>
        <Route path={`${DATA_ADMIN_BASE_PATH}/*`} element={<DataAdminUiRoutes />} />
        <Route path={`${PROJECTS_BASE_PATH}/*`} element={<ProjectsUiRoutes />} />
        {isConceptGroupsEnabled && (
          <Route path={`${CONCEPT_GROUPS_BASE_PATH}/*`} element={<ConceptGroupsUiRoutes />} />
        )}
        <Route path={`${USERS_BASE_PATH}/*`} element={<UsersUiRoutes />} />
        <Route path={`${ORGANIZATIONS_BASE_PATH}/*`} element={<OrganizationsUiRoutes />} />
      </Route>

      {/* Catch all to redirect back to accessible page if unknown */}
      <Route path="*" element={<LandingPage />} />
    </SentryRoutes>
  );
}

export default App;
